import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import { Store } from './store';
import { ThemeProvider } from 'styled-components';

import App from './App';
import GlobalStyles from './components/theme/GlobalStyles';
import colors from './components/theme/colors';
import SocketProvider from './context/socket/provider';
import { AppProvider } from './shared/providers/AppProvider';
import GlobalErrorHandler from './utils/GlobalErrorHandler';

ReactDOM.render(
  <React.StrictMode>
    <GlobalErrorHandler>
      <ThemeProvider theme={colors}>
        <AppProvider>
          <GlobalStyles />
          <Provider store={Store}>
            <SocketProvider>
              <App />
            </SocketProvider>
          </Provider>
        </AppProvider>
      </ThemeProvider>
    </GlobalErrorHandler>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
